import departmentTypes from './departments.types';

export const fetchDepartmentsStart = (channelId) => ({
  type: departmentTypes.FETCH_DEPARTMENTS_START,
  payload: channelId,
});

export const setDepartments = (departments) => ({
  type: departmentTypes.SET_DEPARTMENTS,
  payload: departments,
});

export const loadingDepartments = () => ({
  type: departmentTypes.LOADING_DEPARTMENTS,
});

export const addDepartmentStart = (department, toggleModal) => ({
  type: departmentTypes.ADD_DEPARTMENT_START,
  payload: { department, toggleModal },
});

export const editDepartmentStart = (department, toggleModal) => ({
  type: departmentTypes.EDIT_DEPARTMENT_START,
  payload: { department, toggleModal },
});

export const deleteDepartmentStart = (department, toggleModal) => ({
  type: departmentTypes.DELETE_DEPARTMENT_START,
  payload: { department, toggleModal },
});

export const setLoadingDeleteDepartment = (isLoading) => ({
  type: departmentTypes.SET_LOADING_DELETE_DEPARTMENT,
  payload: isLoading,
});

export const setLoadingEditAddDepartment = (isLoading) => ({
  type: departmentTypes.SET_LOADING_EDIT_ADD_DEPARTMENT,
  payload: isLoading,
});

export const removeDepartmentFromList = (teamId) => ({
  type: departmentTypes.REMOVE_DEPARTMENT_FROM_LIST,
  payload: teamId,
});

export const setEditedDepartment = (editedDepartment) => ({
  type: departmentTypes.SET_EDITED_DEPARTMENT,
  payload: editedDepartment,
});
